import React from 'react';
import StockMonitor from './StockMonitor';
import ErrorBoundary from './components/common/ErrorBoundary';
import { ThemeProvider } from './hooks/useTheme';
import { ToastProvider } from './components/common/Toast';
import { AuthProvider } from './contexts/AuthContext';
import AuthGate from './components/auth/AuthGate';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <AuthGate>
            <ErrorBoundary>
              <StockMonitor />
            </ErrorBoundary>
          </AuthGate>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
